// FullPageLoader.js

import CustomLoader from 'components/CustomLoader';
import React from 'react';

const FullPageLoader = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999, 
      }}
    >
      <CustomLoader />
    </div>
  );
};

export default FullPageLoader;
